// extracted by mini-css-extract-plugin
export default {"centeredImagePreview":"DocumentPreviewContent_centeredImagePreview__q8v79"};